
const APiData
 = {
    GoogleApiKey :"AIzaSyA_vUUk7-lthEghuYmzKv2nJSgLSYvZres",
    baseUrl: "https://api.worldwideadverts.info/"
}

export default APiData;